import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: true,
    darkMode: localStorage.getItem('pos_dark') === 'true',
    language: localStorage.getItem('pos_lang') || 'en',
    snackbar: { open: false, message: '', severity: 'info' },
  },
  reducers: {
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('pos_dark', state.darkMode);
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem('pos_lang', action.payload);
    },
    showSnackbar: (state, action) => {
      state.snackbar = { open: true, ...action.payload };
    },
    hideSnackbar: (state) => {
      state.snackbar = { ...state.snackbar, open: false };
    },
  },
});

export const { toggleSidebar, toggleDarkMode, setLanguage, showSnackbar, hideSnackbar } = uiSlice.actions;
export default uiSlice.reducer;
